import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { DeliverableStatus } from '@/hooks/useDeliverables';

const statusConfig: Record<DeliverableStatus, { label: string; className: string }> = {
  pending: {
    label: 'Pending',
    className: 'bg-gray-100 text-gray-700 border-gray-200',
  },
  in_progress: {
    label: 'In Progress',
    className: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  in_review: {
    label: 'In Review',
    className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  },
  revision: {
    label: 'Revision',
    className: 'bg-orange-100 text-orange-800 border-orange-200',
  },
  approved: {
    label: 'Approved',
    className: 'bg-green-100 text-green-800 border-green-200',
  },
  delivered: {
    label: 'Delivered',
    className: 'bg-emerald-600 text-white border-emerald-600',
  },
};

interface DeliverableStatusBadgeProps {
  status: DeliverableStatus;
  className?: string;
}

export function DeliverableStatusBadge({ status, className }: DeliverableStatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.pending;

  return (
    <Badge variant="outline" className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
}
